import React, { useState, useEffect, useRef, useImperativeHandle, forwardRef } from 'react'
import styled from 'styled-components'
import { useDispatch } from 'react-redux'

import { TabContent, TabPane } from 'reactstrap'

import TabPaneResourceCost from '../tab-resource-cost'
import TabPaneOtherCost from '../tab-other-cost'
import { ToggleTabs } from './toggle-tabs'
import { TabPaneOtherService } from './tab-pane-other-service'
import { TabPaneLicensing } from './tab-pane-licensing'
import { TabPaneHardware } from './tab-pane-hardware'

import { saleProductAction } from '../../../../actions'

import { buttonDiscard } from '../../../project-information/helper/button'
import CustomModalMessage from '../../../modal-message'

export const CostPlanningTab = forwardRef((props, ref) => {
  const access_token = localStorage.getItem('access_token')
  const dispatch = useDispatch()
  const childOtherService = useRef()
  const childLicense = useRef()
  const childHardware = useRef()
  const [activeTab, setActiveTab] = useState(0)
  const [canEdit, setCanEdit] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const {
    hideHeader,
    confirmType,
    confirmStatus,
    confirmMessage,
    /* Resource, Other Cost Tab */
    projectByID,
    rSelected,
    employees,
    showConfirm,
    hideConfirm,
    autoFillManDays,
    editProjectInformation,
    getProjectInformationByID,
    /* Resource, Other Cost Tab */
  } = props
  const presale_snapshot = projectByID && projectByID.presale_snapshot ? projectByID.presale_snapshot.snapshot : null
  const isPresale = presale_snapshot && rSelected === 1

  useImperativeHandle(ref, () => ({
    getIsEdit() {
      return isEdit
    },
    resetIsEdit() {
      setIsEdit(false)
    },
  }))

  useEffect(() => {
    dispatch(saleProductAction.getSaleProduct(access_token))
  }, [])

  useEffect(() => {
    if (projectByID) setCanEdit(projectByID.$can_edit)
  }, [projectByID])

  const handleSetActiveTab = (tab) => {
    if (isEdit) {
      showConfirm({ type: 'discardCostPlanning', tab }, 'Discard Changes', 'Are you sure you want to discard all changes ?')
    } else {
      setIsEdit(false)
      setActiveTab(tab)
    }
  }

  const handleClickEdit = () => {
    switch (activeTab) {
      case 0: {
        this.childResourceCost.editResourceCost()
        break
      }
      case 1: {
        childOtherService.current.editOtherService()
        break
      }
      case 2: {
        childLicense.current.editLicense()
        break
      }
      case 3: {
        childHardware.current.editHardware()
        break
      }
      case 4: {
        this.childOtherCost.editOtherCost()
        break
      }
      default: break
    }
  }

  const handleClickCancel = () => {
    switch (activeTab) {
      case 0: {
        this.childResourceCost.resetProject()
        break
      }
      case 4: {
        this.childOtherCost.resetProject()
        break
      }
      default: break
    }
    setIsEdit(false)
    getProjectInformationByID()
  }

  const handleDiscard = (tab) => {
    hideConfirm('discardCostPlanning')
    setActiveTab(tab)
    handleClickCancel()
  }

  return (
    <Root>
      <CustomModalMessage
        hide={ () => hideConfirm('discardCostPlanning') }
        show={ confirmType && confirmType.type === 'discardCostPlanning' }
        type={ confirmStatus }
        message={ confirmMessage }
        button={ buttonDiscard(confirmType && confirmType.tab, () => hideConfirm('discardCostPlanning'), (tab) => handleDiscard(tab)) }
      />
      <ToggleTabs
        activeTab={ activeTab }
        setActiveTab={ handleSetActiveTab }
        isEdit={ isEdit }
        canEdit={ canEdit }
        isPresale={ isPresale }
        setIsEdit={ setIsEdit }
        clickEdit={ handleClickEdit }
        clickCancel={ handleClickCancel }
      />
      <TabContent activeTab={ activeTab }>
        { activeTab === 0 &&
        <TabPane tabId={ 0 }>
          <TabPaneResourceCost
            onRef={ ref => this.childResourceCost = ref }
            hideHeader={ hideHeader }
            setIsEdit={ setIsEdit }
            editResource={ isEdit }
            rSelected={ rSelected }
            employees={ employees }
            projectByID={ projectByID }
            showConfirm={ showConfirm }
            autoFillManDays={ autoFillManDays }
            editProjectInformation={ editProjectInformation }
            getProjectInformationByID={ getProjectInformationByID }
          />
        </TabPane>
        }
        { activeTab === 1 &&
        <TabPane tabId={ 1 }>
          <TabPaneOtherService
            ref={ childOtherService }
            setIsEdit={ setIsEdit }
            isEdit={ isEdit }
            rSelected={ rSelected }
            projectByID={ projectByID }
            editProjectInformation={ editProjectInformation }
          />
        </TabPane>
        }
        { activeTab === 2 &&
        <TabPane tabId={ 2 }>
          <TabPaneLicensing
            ref={ childLicense }
            setIsEdit={ setIsEdit }
            isEdit={ isEdit }
            rSelected={ rSelected }
            projectByID={ projectByID }
            editProjectInformation={ editProjectInformation }
          />
        </TabPane>
        }
        { activeTab === 3 &&
        <TabPane tabId={ 3 }>
          <TabPaneHardware
            ref={ childHardware }
            setIsEdit={ setIsEdit }
            isEdit={ isEdit }
            rSelected={ rSelected }
            projectByID={ projectByID }
            editProjectInformation={ editProjectInformation }
          />
        </TabPane>
        }
        { activeTab === 4 &&
        <TabPane tabId={ 4 }>
          <TabPaneOtherCost
            onRef={ ref => this.childOtherCost = ref }
            hideHeader={ hideHeader }
            setIsEdit={ setIsEdit }
            editOtherCost={ isEdit }
            projectByID={ projectByID }
            rSelected={ rSelected }
            editProjectInformation={ editProjectInformation }
            getProjectInformationByID={ getProjectInformationByID }
          />
        </TabPane>
        }
      </TabContent>
    </Root>
  )
})

const Root = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #F1F1F1;
`



// WEBPACK FOOTER //
// ./src/components/project-information/tab-content/tab-cost-planning/index.js